import React from "react";
import { cn } from "../../../../../../helpers";
import { useDataMan } from "../../hooks/useDataMan";
import { DataManBulkActionsFooter } from "../common/DataManBulkActionsFooter";
import { DataManLoadMore } from "../common/DataManLoadMore";
import { DataManCompactViewRecord } from "./DataManCompactViewRecord";

export const DataManCompactViewWrapper: React.FC = () => {
  const { data, emptyState, fullSize, hasBulkSelection, selectedItems } =
    useDataMan();

  const hasData = data && data.length > 0;
  const hasSelectedItems = selectedItems.length > 0;
  const showBulkActionsFooter = hasBulkSelection && hasSelectedItems;

  if (!hasData) {
    return (
      <div className="flex items-center justify-center py-12 text-content">
        {emptyState || "No data available"}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative flex w-full flex-col overflow-hidden",
        fullSize && "h-full overflow-auto"
      )}
    >
      {/* Records list */}
      <div className="flex w-full flex-col">
        {data.map((item, index) => (
          <DataManCompactViewRecord
            key={item.id || index}
            data={item}
            index={index}
            totalCount={data.length}
          />
        ))}
      </div>

      {/* Load more button */}
      <DataManLoadMore />

      {/* Bulk actions footer */}
      {showBulkActionsFooter && <DataManBulkActionsFooter />}
    </div>
  );
};
